import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ManageContentAssociationTypes = ({ location }) => {
  let parms = new URLSearchParams(location.search);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const history = useHistory();
  const [state, setState] = useState({
    contentAssociationTypeId: parseInt(parms.get("id")),
    contentAssociationTypeName: "",
    contentAssociationTypeDescr: "",
    contentAssociationTypeAppid: 0,
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-association-types/${state.contentAssociationTypeId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(
          response.status + ":" + response.data.contentAssociationTypeId
        );

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  const handleOnLoad = () => {
    console.log(
      "handleOnLoad() - loading id = " + state.contentAssociationTypeId
    );
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-association-types/${state.contentAssociationTypeId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  function onDelete() {
    let deleteID = state.contentAssociationTypeId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-association-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        history.goBack();
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => history.goBack()}
        >
          Go Back
        </button>
        <h4>Content Association Type Details</h4>
        <hr />
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Association Type"
          >
            Content Association Type
          </label>
          <select
            id="contentAssociationTypeId"
            className="form-control input-xlarge col-sm-8"
            onchange="submit()"
            value="#{ombContentAssociationTypeForm.currentContentAssociationType.contentAssociationTypeId}"
            valueChangeListener="#{ombContentAssociationTypeForm.get }"
          >
            <option value="#{ombContentAssociationTypeForm.contentAssociationTypeSelectList}" />
          </select>
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Association Type Name"
          >
            Content Association Type name
          </label>
          <input
            id="contentAssociationTypeName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentAssociationTypeName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Association Type Description"
          >
            Content Association Type Description
          </label>
          <textarea
            id="contentAssociationTypeDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentAssociationTypeDescr}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Association Application"
          >
            Content Association Application
          </label>
          <select
            id="contentAssociationTypeId"
            value="#{ombContentAssociationTypeForm.createContentAssociationType.contentAssociationTypeAppid}"
            className="form-control input-xlarge col-sm-8"
          >
            <option value="#{ombContentAssociationTypeForm.contentApplicationSelectList}" />
          </select>
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Last Updated By #{ombUserSession.getUserNameForId(contentTemplateForm.currentContentTemplate.lastUpdateUser)} on "
          >
            Last Updated By
          </label>
          <input
            className="form-control col-sm-1"
            readonly="readonly"
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="#{contentTemplateForm.currentContentTemplate.lastUpdateDate}"
          >
            Last Update Date
          </label>
          <input
            className="form-control col-sm-8"
            readonly="readonly"
            value={state.lastUpdateDate.slice(0, 16)}
            type="datetime-local"
          />
        </div>
        <hr />
        <button
          className="btn btn-danger"
          value="Delete"
          onClick={onDelete}
        >
          {" "}
          Delete
        </button>
        &nbsp;
        <button className="btn btn-success" value="Save" onClick={handleSave}>
          {" "}
          Save
        </button>
        &nbsp;

      </div>
    </form>
  );
};

export default ManageContentAssociationTypes;
